import React      from 'react';
import { Helmet } from 'react-helmet';
import shop       from "shop/shop"

const SEO = ( { seo } ) => {
  const seoDefault = shop.seoDefault || {}
  const seoData = Object.assign( {}, seoDefault, seo )
  const { url, type, lang, image, title, description, facebookAppId } = seoData
  return (
    <Helmet>
      <title>{`${title} | ${process.env.REACT_APP_SHOP_TITLE}`}</title>
      <meta name="description" content={description}/>
      {/*<meta name="twitter:card" content="summary_large_image" />        */}
      {/*<meta name="twitter:site" content="@user" />       */}
      {/*<meta name="twitter:creator" content="@user" />       */}
      {/*<meta name="twitter:title" content="Pets - Products" />       */}
      {/*<meta name="twitter:description" content="Best Products for your pet" />       */}
      {/*<meta name="twitter:image" content="url_to_image"/>       */}
      <meta property="og:title" content={title}/>
      <meta property="og:description" content={description}/>
      <meta property="og:image" content={image}/>
      
      <meta property="og:url" content={url}/>
      <meta property="og:site_name" content={title}/>
      <meta property="og:locale" content={lang}/>
      <meta property="og:type" content={type || "website"}/>
      {facebookAppId && <meta property="fb:app_id" content={facebookAppId}/>}
    </Helmet>
  )
};

export const SEOProduct = ( { product, category } ) => {
  if(!product) return null
  return <SEO seo={{
    url: `${process.env.REACT_APP_API}/product/${product.map_id}`,
    title: product.desc.short_des,
    description: product.desc.des,
    image: product.image
  }
  }/>
}

export const SEOCategory = ( { product, category, seo } ) => {

  if(seo){
    return <SEO seo={{
      url: `${process.env.REACT_APP_API}/collection/${category.map_id}`,
      title: seo.yoast_head_json.title || category.desc.short_des,
      description: seo.yoast_head_json.description || category.desc.des,
      image: category.image
    }}/>
  }
  if(!category || !category.desc) return null
  return <SEO seo={{
    url: `${process.env.REACT_APP_API}/collection/${category.map_id}`,
    title: category.desc.short_des,
    description: category.desc.des,
    image: category.image
  }}/>
}

export const SEOPage = ( { product, page } ) => {
  if ( !page || !page.title ) return null
  return <SEO seo={{
    url: `${process.env.REACT_APP_API}/cms/${page.slug}`,
    title: page.title && page.title.rendered,
    description: page.excerpt && page.excerpt.rendered,
    image: page.image
  }}/>
}

export default SEO;


// WEBPACK FOOTER //
// ./src/components/SEO.js